import {find, filter, difference} from 'lodash';
import {availableCountries} from "app/static/countries";
import {Collection} from "app/lib/collection";
import {Translate} from "app/services/translate";
import {replacePolishCharacterAsLowerCase} from "app/lib/polishAlphabet";

export const sortCountriesBySuggested = (countries) => {
    const suggestedCountries = filter(availableCountries, (c) => c.suggested);
    const suggested = new Collection(countries)
        .map((country) => find(suggestedCountries, {code: country}))
        .filter(Boolean)
        .sort('order')
        .property('code')
        .items;
    const rest = new Collection(difference(countries, suggested))
        .map((item) => {
            return {code: item, name: Translate(`country_${item.toLowerCase()}_genitive`)};
        })
        .sort((i) => replacePolishCharacterAsLowerCase(i.name))
        .property('code')
        .items;

    return [...suggested, ...rest];
};
